const postMessageType = 'themeChange';
const ATTR_NAME = 'data-theme';
const sendThemeChangedPostMessage = (windowForPostMessage, theme, domain) => {
    if (typeof windowForPostMessage.postMessage === 'undefined')
        return;
    windowForPostMessage.postMessage({ type: postMessageType, value: theme }, domain || '*');
};

export { ATTR_NAME, postMessageType, sendThemeChangedPostMessage };
//# sourceMappingURL=theme.js.map
